<!-- 团体排名-->
<template>
<div class="" v-if="isShow">
    <PageBack :title="title" />
    <!-- <el-button class="mg-t-20" @click="handleExport" type="success" size="medium">导出成绩</el-button> -->
    <div class="custom-table custom-table2">
        <div class="size20 center mg-b-10 bold">{{ pubTitle }}</div>
        <el-table :data="tableData" :row-class-name="tableRowClassName" 
            style="width: 100%" border>
            <el-table-column   
                v-for="(item, index) in dynamicHeaders"
                :key="index"
                :prop="item.prop"
                :label="item.label" 
                align="center">
            </el-table-column>
        </el-table>
    </div>
</div>

</template>

<script>
import PageBack from '@/components/PageHeader'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
    components:{
        PageBack
    },
    data(){
        return{
            isShow: false,
            tableData:[],
            tableHeaders: [
                 {label: '名次', prop: 'rank'},
                {label: '单位',prop: 'company'},
                {label: '总升级', prop: 'winNum'},
                {label: '第1轮_组A', prop: 'roud1A'},
                {label: '第1轮_组B', prop: 'round1B'},               
                {label: '第1轮_组A升级', prop: 'level1A'},
                {label: '第1轮_组B升级', prop: 'level1B'},   

                {label: '第2轮_组A', prop: 'roud2A'},
                {label: '第2轮_组B', prop: 'round2B'},               
                {label: '第2轮_组A升级', prop: 'level2A'},
                {label: '第2轮_组B升级', prop: 'level2B'}, 

                {label: '第3轮_组A', prop: 'roud3A'},
                {label: '第3轮_组B', prop: 'round3B'},               
                {label: '第3轮_组A升级', prop: 'level3A'},
                {label: '第3轮_组B升级', prop: 'level3B'},

                {label: '第4轮_组A', prop: 'roud4A'},
                {label: '第4轮_组B', prop: 'round4B'},               
                {label: '第4轮_组A升级', prop: 'level4A'},
                {label: '第4轮_组B升级', prop: 'level4B'},
            ],
            dynamicHeaders:[],
            pubTitle: '',
            exportData: [],
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        }, 
        publishId(){
            return this.$route.query.id
        } 
    },
    created(){
        
    },
    mounted() {
        if(this.publishId){
            this.getQuery()
            // this.getTableHeaders()
        }
        this.initData()
    },
    methods: {
        tableRowClassName({row, rowIndex}){
            // 前三名不同的颜色
            if(row.rank === 1){
                return 'gold-row'
            }else if(row.rank === 2){
                return  'silver-row'
            }else if(row.rank === 3){
                return  'brown-row'
            }
        },
        getTableHeaders(){
            let params = {
                opcode: this.$code.TableHeaderCode,
                i_serial_mark:this.publishId,

            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                         
                    // console.log(result[0])   
                    let arr =  Object.keys(result[0])    
                    // console.log(arr)  
                    let newData = []   
                    for (let key of arr) {                       
                        let newArr = key.split('-')                     
                        newData.push({
                            label: newArr[0],
                            id: newArr[1]
                        }); 
                    }
                    // console.log(newData)
                    let outputArry = this.transformObjectToArray(newData)
                    // console.log(outputArry)
                }
            })
        },
        getQuery(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.publishId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable[0]
                    this.pubTitle = result['主题']
                }
            })
        },
        initData(){
            let params = {
                opcode: this.$code.GroupRankCode,
                i_serial_mark: this.publishId
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){

                        this.tableData = result.map(item=>{                    
                            return{                               
                                rank: item['名次'],
                                company: item['单位'],                            
                                winNum: item['总升级'],    
                                roud1A: item['第1轮_组A'],                           
                                roud1B: item['第1轮_组B'],
                                level1A: item['第1轮_组A升级'],
                                level1B: item['第1轮_组B升级'],

                                roud2A: item['第2轮_组A'],                           
                                roud2B: item['第2轮_组B'],
                                level2A: item['第2轮_组A升级'],
                                level2B: item['第2轮_组B升级'],

                                roud3A: item['第3轮_组A'],                           
                                roud3B: item['第3轮_组B'],
                                level3A: item['第3轮_组A升级'],
                                level3B: item['第3轮_组B升级'],
                                
                                roud4A: item['第4轮_组A'],                           
                                roud4B: item['第4轮_组B'],
                                level4A: item['第4轮_组A升级'],
                                level4B: item['第4轮_组B升级'],
                            }
                        })  
                    // 导出数据过滤掉了选手编号，使用map创建一个新数组，排除'选手编号'字段（不修改原数组）
                    this.exportData = result.map(item=>{
                        const { 选手编号, ...rest } = item;
                        return rest
                    })
                    // 导出的数据，返回一个表头
                    let outputArry = this.transformObjectToLabelPropArray(result[0])
                    this.isShow = true
                    // 获取所有唯一的字段名
                    const fields = Array.from(new Set(this.tableData.flatMap(Object.keys)));
                    // 过滤出至少有一个非空值的字段
                    let arr= fields.filter(field => this.tableData.some(row => row[field] !== null && row[field] !== undefined && row[field] !== ''));

                    this.dynamicHeaders = outputArry.filter(i=>arr.includes(i.prop))

                    }else{
                        this.$message.error('暂无成绩')
                    }                               
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        transformToArray(obj){
            const result = []     
            for (const key of obj) {
                if(obj.hasOwnProperty(key)){
                    result.push({
                        label: key.label,
                        prop: mapping[key]
                    });
                }
            }
            return result
        },
        transformObjectToLabelPropArray(obj) {
            const result = [];
            const mapping = {
               '名次': 'rank',
                '单位': 'company',             
                '总升级': 'winNum',
                '第1轮_组A': 'roud1A',
                '第1轮_组B': 'roud1B',
                '第1轮_组A升级': 'level1A',
                '第1轮_组B升级': 'level1B',

                '第2轮_组A': 'roud2A',
                '第2轮_组B': 'roud2B',
                '第2轮_组A升级': 'level2A',
                '第2轮_组B升级': 'level2B',

                '第3轮_组A': 'roud3A',
                '第3轮_组B': 'roud3B',
                '第3轮_组A升级': 'level3A',
                '第3轮_组B升级': 'level3B',

                '第4轮_组A': 'roud4A',
                '第4轮_组B': 'roud4B',
                '第4轮_组A升级': 'level4A',
                '第4轮_组B升级': 'level4B',
            };        
            for (let key in obj) {
                if (obj.hasOwnProperty(key) && mapping.hasOwnProperty(key)) {                  
                    result.push({
                        label: key,
                        prop: mapping[key]
                    });
                }
            }        
            return result;
        },
        // 导出表格
        handleExport(){
            // 假设有一个表格数据的数组
            // console.log(this.exportData)
            // aoa_to_sheet array
            // const data = [
            //     ["选手编号","选手姓名", "搭档姓名", "选手手机号","搭档手机号","协会（俱乐部）"],
            //     []
            // ];
        
            // 将数据转换为工作表
            const worksheet = XLSX.utils.json_to_sheet(this.exportData);
        
            // 创建工作簿并添加工作表
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        
            // 生成Excel文件
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        
            // 使用blob和FileReader创建一个Blob URL   type: application/octet-stream
            const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream;charset=UTF-8' });
            const blobUrl = window.URL.createObjectURL(dataBlob);
        
            // 使用saveAs下载文件
            saveAs(dataBlob, `${this.pubTitle}.xlsx`);
        
            // 清理
            window.URL.revokeObjectURL(blobUrl);
        },
    },
}
</script>
<style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .custom-table >>> .el-table__header-wrapper tr th{
    font-size: 16px;
    color: #000;
}
.custom-table .el-table__cell{
    font-size: 20px;
}
.custom-table >>> .el-table{
    font-size: 20px;
}
.custom-table >>> .el-table .cell{
    font-size: 20px;
}
.custom-table >>> .el-input{
    font-size: 20px;
}
.custom-table >>> .gold-row{
    background-color: #FFD700;
}
.custom-table >>> .silver-row{
    background-color: #C0C0C0;
}
.custom-table >>> .brown-row{
    background-color: #CD7F32;
}
</style>


// WEBPACK FOOTER //
// src/views/playerScore/teamGroupRankQuery.vue